import SendFiles from './SendFiles'
export default SendFiles
